import styled from "styled-components";

import theme from "@/constants/theme";
import { colorType } from "@/constants/types";

import { StatusType, variantColor, variantHeight, VariantType } from "./types";

interface SimpleButtonProps {
  variant: VariantType;
  status?: StatusType;
  label?: React.ReactNode;
  $backgroundColor?: colorType;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
  title?: string;
  icon?: React.ReactNode;
  iconLeft?: React.ReactNode;
}

const height = ({ variant }: SimpleButtonProps) => {
  return variantHeight[variant];
};

const backgroundColor = ({ status, $backgroundColor }: SimpleButtonProps) => {
  if ($backgroundColor) {
    return theme.colors[$backgroundColor];
  } else {
    if (status) {
      return variantColor[status];
    } else {
      return theme.colors.black;
    }
  }
};

export const Container = styled.button<SimpleButtonProps>`
  width: ${(props) => (props.variant === "back" ? "fit-content" : "100%")};
  height: ${(props) => height(props)};
  background-color: ${(props) => backgroundColor(props)};
  border-radius: 56px;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  padding: ${(props) =>
    !props.label ? "0px 16px" : props.variant === "back" ? "0px 20px 0px 16px" : "0px 16px"};
  gap: 8px;
  border: none;
  cursor: pointer;
  white-space: nowrap;

  .info-button {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
  }

  .icon-left {
    padding-right: 0px;
    font-size: 20px;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .loading-size {
    width: 60px;
  }
`;
